import { render, staticRenderFns } from "./EditApprobation.vue?vue&type=template&id=708037d2&scoped=true&"
import script from "./EditApprobation.vue?vue&type=script&lang=js&"
export * from "./EditApprobation.vue?vue&type=script&lang=js&"
import style0 from "./EditApprobation.vue?vue&type=style&index=0&id=708037d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708037d2",
  null
  
)

export default component.exports